import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sortIcon'
})
export class SortIconPipe implements PipeTransform {
  transform(
    column: 'name' | 'orders' | 'quantity' | 'total',
    sortColumn: 'name' | 'orders' | 'quantity' | 'total',
    sortDirection: 'asc' | 'desc'
  ): string {
    if (sortColumn !== column) {
      return ''; // No icon for inactive columns
    }
    return sortDirection === 'asc' ? 'chevron-up' : 'chevron-down';
  }
}
